import { Pill, PILL_COLORS } from "components/ui/Pill";

const toTitleCase = (value) =>
  value
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const drugsFileColumns = [
  {
    key: "manufacturer",
    header: "Trade Name",
    width: "225px",
    render: (row) => row.manufacturer || "-",
  },
  {
    key: "tradeName",
    header: "Generic Name",
    width: "430px",
    render: (row) => row.tradeName || "-",
  },
  {
    key: "genericName",
    header: "Manufacturer",
    width: "280px",
    render: (row) => row.genericName || "-",
  },
  {
    key: "form",
    header: "Form",
    width: "170px",
    render: (row) => {
      if (!row.form) return "-";

      return <Pill {...PILL_COLORS.method}>{toTitleCase(row.form)}</Pill>;
    },
  },
  {
    key: "strength",
    header: "Strength",
    width: "105px",
    render: (row) => row.strength || "-",
  },
  {
    key: "packSize",
    header: "Pack Size",
    width: "110px",
    render: (row) => row.packSize || "-",
  },
];
